import { Injectable } from '@angular/core'
import { environment } from '@candidate/environments/environment'
import { RestApiClient } from '@engineering11/web-api-rest'
import { firstValueFrom } from 'rxjs'
import { map } from 'rxjs/operators'
import { DEFAULT_NETWORK_MONITORING_CONFIG, getBaseSuffix, TokenStorage } from 'shared-lib'

export interface ICandidateAbandonRegistrationRequest {
  email: string
  firstName: string
  lastName: string
  jobPostId?: string
  authTenantId: string
}

@Injectable({ providedIn: 'root' })
export class AbandonRegistrationService {
  private restApiClient: RestApiClient
  constructor(tokenStorage: TokenStorage) {
    this.restApiClient = new RestApiClient({
      baseUrl: environment.services.registration,
      token: () => tokenStorage.getAccessToken(),
      baseSuffix: getBaseSuffix(environment, 'registration'),
      ...DEFAULT_NETWORK_MONITORING_CONFIG,
    })
  }

  queueAbandonNotification(req: ICandidateAbandonRegistrationRequest): Promise<any> {
    return firstValueFrom(this.restApiClient.post(`abandon-registration`, req).pipe(map(res => res.data)))
  }
}
